import { render } from "./newsDetail.vue?vue&type=template&id=af2d2cf0&scoped=true"
import script from "./newsDetail.vue?vue&type=script&lang=js"
export * from "./newsDetail.vue?vue&type=script&lang=js"

import "./newsDetail.vue?vue&type=style&index=0&id=af2d2cf0&lang=scss&scoped=true"
import "./newsDetail.vue?vue&type=style&index=1&id=af2d2cf0&lang=scss"

import exportComponent from "F:\\Code3\\medical-website---web\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+comp_0e94901392e05a49343df8105549c0e4\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af2d2cf0"]])

export default __exports__